import React, { useState, useEffect } from 'react';
import { Send, Brain, RotateCcw, AlertTriangle, CheckCircle, Loader2, X as IconX } from 'lucide-react';

const ClientProjectSupportPopup = ({
  isOpen,
  file, // obiekt pliku, dla którego jest popup
  orderEmail, // Przekazywany email zamówienia do inicjalizacji
  onClose,
  onSubmitRequest, // funkcja z ClientOrderPanel (będzie przyjmować tekst i email)
  onRestoreVersion, // funkcja z ClientOrderPanel
  // backendUrl, // Nie jest już bezpośrednio używany, operacje wykonuje ClientOrderPanel
  supportOption,
  setSupportOption,
  // clientRequestText, // Zarządzany lokalnie
  // setClientRequestText, // Zarządzany lokalnie
  // clientEmail, // Zarządzany lokalnie
  // setClientEmail, // Zarządzany lokalnie
  isLoading, // stan ładowania z ClientOrderPanel
  statusMessage, // obiekt statusu z ClientOrderPanel (ustawiany przez ClientOrderPanel)
  currentHistoryId, // ID aktualnej historii, pobrane w ClientOrderPanel
  aiModifiedHistoryId, // ID historii po modyfikacji AI, zarządzane w ClientOrderPanel
  previousVersionIdForAi, // ID historii sprzed modyfikacji AI, zarządzane w ClientOrderPanel
  // setIsAiProcessing, // To jest teraz obsługiwane przez ClientOrderPanel na podstawie isLoading i supportOption
}) => {
  const [localClientRequestText, setLocalClientRequestText] = useState('');
  const [localClientEmail, setLocalClientEmail] = useState('');

  useEffect(() => {
    if (isOpen && file) {
      // Resetuj stany przy każdym otwarciu dla nowego pliku lub ponownym otwarciu
      setLocalClientRequestText('');
      setLocalClientEmail(orderEmail || '');
    }
  }, [isOpen, file, orderEmail]);

  // Efekt do czyszczenia tekstu po pomyślnym wysłaniu (jeśli statusMessage to sukces)
  // To jest opcjonalne, bo ClientOrderPanel może zamknąć popup lub zresetować go inaczej
  useEffect(() => {
    if (statusMessage && statusMessage.type === 'success' && statusMessage.text.includes("Prośba została wysłana") ) { // Załóżmy, że taki tekst jest przy sukcesie
      setLocalClientRequestText('');
      // Nie resetujemy emaila, bo może być potrzebny do kolejnej prośby grafika
    }
  }, [statusMessage]);

  // console.log('[ClientProjectSupportPopup] Rendering. isOpen:', isOpen, 'File:', file);

  if (!isOpen || !file) {
    // console.log('[ClientProjectSupportPopup] Not rendering because isOpen is false or file is null.');
    return null;
  }
  // console.log('[ClientProjectSupportPopup] All conditions met, rendering popup.');

  const handleInternalSendRequest = () => {
    onSubmitRequest(localClientRequestText, localClientEmail);
    // Opcjonalnie: wyczyść localClientRequestText tutaj, jeśli onSubmitRequest nie zamyka od razu popupa
    // lub jeśli ClientOrderPanel nie odświeża statusMessage, które by to wyczyściło
    // Na razie zakładamy, że ClientOrderPanel obsłuży reset/zamknięcie
  };

  const handleInternalRestoreVersion = () => {
    // onRestoreVersion jest już funkcją z ClientOrderPanel
    onRestoreVersion();
  };

  const renderForm = () => (
    <div style={{ padding: '15px', paddingTop: 0 }}>
      <textarea
        value={localClientRequestText}
        onChange={(e) => setLocalClientRequestText(e.target.value)}
        placeholder={supportOption === 'graphic' ? "Opisz, jakie zmiany chciałbyś zlecić grafikowi..." : "Opisz, jak AI ma poprawić Twój projekt..."}
        rows="5"
        style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box', marginBottom: '10px' }}
        disabled={isLoading}
      />
      {((supportOption === 'graphic' || supportOption === 'ai') && !orderEmail) && (
        <input
          type="email"
          value={localClientEmail}
          onChange={(e) => setLocalClientEmail(e.target.value)}
          placeholder="Twój adres email do kontaktu"
          style={{ width: '100%', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', boxSizing: 'border-box', marginBottom: '10px' }}
          disabled={isLoading}
        />
      )}
      <button
        onClick={handleInternalSendRequest}
        disabled={isLoading}
        style={{
          backgroundColor: isLoading ? '#ccc' : '#007bff',
          color: 'white',
          padding: '10px 15px',
          border: 'none',
          borderRadius: '4px',
          cursor: isLoading ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          marginBottom: (isLoading && supportOption === 'ai') ? '10px' : '0' // Dodatkowy margines dla komunikatu AI
        }}
      >
        {isLoading ? <Loader2 size={20} className="animate-spin" /> : <Send size={18} />}
        <span style={{ marginLeft: '8px' }}>{isLoading ? 'Wysyłanie...' : 'Wyślij prośbę'}</span>
      </button>
      {isLoading && supportOption === 'ai' && (
        <p style={{ fontSize: '12px', color: '#555', textAlign: 'center', marginTop: '10px', marginBottom: '0' }}>
          Generowanie nowego projektu przez AI może potrwać kilka minut.
          Możesz zamknąć to okno. O wyniku poinformujemy Cię mailowo.
        </p>
      )}
    </div>
  );

  return (
    <div className="client-support-popup-overlay"> {/* Zmieniona klasa */}
      <div className="client-support-popup-content" style={{ fontFamily: 'Arial, sans-serif', width: '90%', maxWidth: '500px' }}> {/* Zmieniona klasa */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px', borderBottom: '1px solid #eee' }}>
          <h3 style={{ margin: '0', fontSize: '18px' }}>Poproś o zmiany w projekcie</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
            <IconX size={24} />
          </button>
        </div>

        <div style={{ padding: '15px' }}>
          <p style={{marginTop: 0, marginBottom: '15px'}}>Projekt: <strong>{file.fileName}</strong></p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '15px' }}>
            <button
              onClick={() => setSupportOption('graphic')}
              style={{
                padding: '14px 10px',
                border: supportOption === 'graphic' ? '2px solid #0056b3' : '1px solid #ccc',
                borderRadius: '4px',
                backgroundColor: supportOption === 'graphic' ? '#cce7ff' : '#007bff',
                color: supportOption === 'graphic' ? '#0056b3' : 'white',
                cursor: 'pointer',
                fontSize: '14px',
                textAlign: 'center'
              }}
              disabled={isLoading}
            >
              Poproś grafika o zmiany
            </button>
            <button
              onClick={() => setSupportOption('ai')}
              style={{
                padding: '14px 10px',
                border: supportOption === 'ai' ? '2px solid #003d80' : '1px solid #ccc',
                borderRadius: '4px',
                backgroundColor: supportOption === 'ai' ? '#b3d7ff' : '#0056b3',
                color: supportOption === 'ai' ? '#003d80' : 'white',
                cursor: 'pointer',
                fontSize: '14px',
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              disabled={isLoading}
            >
              <div>
                <Brain size={16} style={{ marginRight: '5px', verticalAlign: 'middle' }} />
                Popraw projekt z AI
              </div>
              <span style={{ fontSize: '10px', marginTop: '4px', opacity: 0.8 }}>
                (nowy projekt zostanie przygotowany w ciągu ok 5 min)
              </span>
            </button>
          </div>
        </div>

        {supportOption && renderForm()}

        {statusMessage && statusMessage.text && (
          <div style={{
            margin: '0 15px 15px 15px',
            padding: '10px',
            borderRadius: '4px',
            backgroundColor: statusMessage.type === 'success' ? '#d4edda' : (statusMessage.type === 'error' ? '#f8d7da' : '#e2e3e5'),
            color: statusMessage.type === 'success' ? '#155724' : (statusMessage.type === 'error' ? '#721c24' : '#383d41'),
            border: `1px solid ${statusMessage.type === 'success' ? '#c3e6cb' : (statusMessage.type === 'error' ? '#f5c6cb' : '#d6d8db')}`,
            display: 'flex',
            alignItems: 'center'
          }}>
            {statusMessage.type === 'success' && <CheckCircle size={18} style={{ marginRight: '8px' }} />}
            {statusMessage.type === 'error' && <AlertTriangle size={18} style={{ marginRight: '8px' }} />}
            {statusMessage.text}
          </div>
        )}

        {supportOption === 'ai' && previousVersionIdForAi && aiModifiedHistoryId && (
          <div style={{ padding: '0 15px 15px 15px' }}>
            <button
              onClick={handleInternalRestoreVersion}
              disabled={isLoading}
              style={{
                backgroundColor: isLoading ? '#ccc' : '#6c757d',
                color: 'white',
                padding: '10px 15px',
                border: 'none',
                borderRadius: '4px',
                cursor: isLoading ? 'not-allowed' : 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                marginTop: '10px'
              }}
            >
              {isLoading ? <Loader2 size={20} className="animate-spin" /> : <RotateCcw size={18} />}
              <span style={{ marginLeft: '8px' }}>Przywróć wersję sprzed edycji AI</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientProjectSupportPopup;
